import {Link, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {toast} from "react-toastify";
import {
    EmailTemplates,
    encryptData,
    formatDateAndTime,
    projectName,
    sendEmail,
    showAlert
} from "../../resources/constants";
import {setApplicationDetails, setLoginDetails} from "../../actions/actions";
import {connect} from "react-redux";
import logo from "../../images/logo.png";

function ForgotPassword(props) {

    const navigate = useNavigate();
    const [login, setLogin] = useState({
        RecoveryEmail: ""
    });


    const handleForgetPassword = async (e) => {
        e.preventDefault();
        toast.info("please wait...")
        const token = "pa" + Math.floor(Math.random() * 999999999);
        const email = EmailTemplates('8', encryptData(token));

        await axios.get(`${serverLink}application/registration/${login.RecoveryEmail}`, { token: encryptData(token) }).then(async (res) => {
            if (res.data.length > 0) {
                await axios.patch(`${serverLink}application/forget_password/add_token/${login.RecoveryEmail}`, { token: encryptData(token) })
                    .then((result) => {
                        if (result.data.message === "success") {
                            toast.success('An email have been sent to your mailbox, please check and proceed.')
                            sendEmail(
                                login.RecoveryEmail, email.subject, email.title, login.RecoveryEmail, email.body, '', ''
                            )
                        } else {
                            // toast.error('Please try again.')
                        }
                    }).catch((e) => {
                        console.log('NETWORK ERROR')
                    })
            } else {
                showAlert("Error", "The email provided is not registered", "error")
            }

        })

    }

    const onEdit = (e) => {
        if (e.target.id === "RecoveryEmail")
            setLogin({
                ...login,
                RecoveryEmail: e.target.value
            });
        else
            setLogin({
                ...login,
                [e.target.id]: e.target.value,
            });
    };
    return (
        <>
            {/* Main Wrapper */}
            <div className="main-wrapper">
                <div className="container-fuild">
                    <div className="login-wrapper w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
                        <div className="row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', maxHeight: '85vh' }}>
                            {/*<div className="col-lg-6">*/}
                            {/*    <div className="d-lg-flex align-items-center justify-content-center bg-light-300 d-lg-block d-none flex-wrap vh-100 overflowy-auto bg-01">*/}
                            {/*        <div>*/}
                            {/*            <img*/}
                            {/*                src="assets/img/authentication/authentication-06.svg"*/}
                            {/*                alt="Img"*/}
                            {/*            />*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                                    <div className="col-md-8 mx-auto p-4">
                                        <form onSubmit={handleForgetPassword}>
                                            <div>
                                                <div className=" mx-auto mb-5 text-center">
                                                    <img
                                                        src={logo}
                                                        className="img-fluid"
                                                        alt="Logo"
                                                        width={100}
                                                    />
                                                </div>
                                                <div className="card">
                                                    <div className="card-body p-4">
                                                        <div className=" mb-4">
                                                            <h2 className="mb-2">Forgot Password</h2>
                                                            <p className="mb-0">
                                                                Please enter your email address to reset password
                                                            </p>
                                                        </div>
                                                        <div className="login-or">
                                                            <span className="span-or">Or</span>
                                                        </div>
                                                        <div className="mb-3 ">
                                                            <label className="form-label">Email Address</label>
                                                            <div className="input-icon mb-3 position-relative">
                            <span className="input-icon-addon">
                              <i className="ti ti-mail" />
                            </span>
                                                                <input
                                                                    type="email"
                                                                    defaultValue=""
                                                                    className="form-control"
                                                                    onChange={onEdit} id="RecoveryEmail"
                                                                />
                                                            </div>

                                                        </div>
                                                        <div className="mb-3">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary w-100"
                                                            >
                                                                Reset Password
                                                            </button>
                                                        </div>
                                                        <div className="text-center">
                                                            <h6 className="fw-normal text-dark mb-0">
                                                                Don’t have an account?{" "}
                                                                <Link to="/register" style={{color:"#007bff"}}>
                                                                    Register here
                                                                </Link>
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-5 text-center">
                                                    <p className="mb-0 ">Copyright © {formatDateAndTime(new Date(), 'year_only')} {projectName} All Rights Reserved</p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
